"use client";

import { CheckCircle2, Loader2, RefreshCw, XCircle } from "lucide-react";

import { Button } from "@/components/ui/button";

export function QrisSuccessView({ message }: { message: string }) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-8 text-center"
      role="status"
      aria-live="polite"
    >
      <CheckCircle2
        className="h-12 w-12 text-status-success-text"
        aria-hidden="true"
      />
      <p className="text-lg font-semibold text-text-heading">{message}</p>
    </div>
  );
}

export function QrisFailedView({
  message,
  retryLabel,
  onRetry,
}: {
  message: string;
  retryLabel: string;
  onRetry?: () => void;
}) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-8 text-center"
      role="status"
      aria-live="polite"
    >
      <XCircle
        className="h-12 w-12 text-status-error-text"
        aria-hidden="true"
      />
      <p className="text-lg font-semibold text-text-heading">{message}</p>
      {onRetry ? (
        <Button onClick={onRetry} className="min-h-11 gap-2">
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}

export function QrisExpiredView({
  message,
  newQrLabel,
  errorMessage,
  isReissuing,
  onReissue,
}: {
  message: string;
  newQrLabel: string;
  errorMessage: string | null;
  isReissuing: boolean;
  onReissue: () => void;
}) {
  return (
    <div
      className="flex flex-col items-center justify-center gap-4 py-8 text-center"
      role="status"
      aria-live="polite"
    >
      <XCircle
        className="h-12 w-12 text-status-error-text"
        aria-hidden="true"
      />
      <p className="text-lg font-semibold text-text-heading">{message}</p>
      <Button
        onClick={onReissue}
        disabled={isReissuing}
        className="min-h-11 gap-2"
      >
        {isReissuing ? (
          <Loader2
            className="h-4 w-4 animate-spin motion-reduce:animate-none"
            aria-hidden="true"
          />
        ) : (
          <RefreshCw className="h-4 w-4" aria-hidden="true" />
        )}
        {newQrLabel}
      </Button>
      {errorMessage ? (
        <p className="text-sm text-status-error-text" role="alert">
          {errorMessage}
        </p>
      ) : null}
    </div>
  );
}
